module.exports = __webpack_public_path__ + "static/media/empty-member.78e9a750.svg";